import { trim } from "lodash-es";

export function notEmpty(data: string): string {
  if (!trim(data)) {
    return "Field cannot be blank!";
  }
  return "";
}
